export default __webpack_public_path__ + "static/media/wi-fi_bold.eaf72479.svg";